import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import Product from '../../Assets/images/icons/icon-product.png'
import User from '../../Assets/images/icons/icon-users.png'
import Comp from '../../Assets/images/icons/icon-comp.png'
import Chart from 'react-apexcharts';
import { showToast } from '../../Components/Toast'
import { getDashboardData } from '../../API/Backend'
import Skeleton from "react-loading-skeleton";

export default function Dashboard() {

  // const statData = [
  //   {
  //     icon: <img src={Product} alt="Products" width="30" height="30" />,
  //     iconBg: '#fff9e6',
  //     count: '2,64,123',
  //     label: 'Total products'
  //   },
  //   {
  //     icon: <img src={User} alt="Products" width="30" height="30" />,
  //     iconBg: '#f5ede7',
  //     count: '2,64,123',
  //     label: 'Users'
  //   },
  //   {
  //     icon: <img src={Comp} alt="Products" width="30" height="30" />,
  //     iconBg: '#eaf8f9',
  //     count: '2,64,123',
  //     label: 'Active Comparisons'
  //   }
  // ];
  const chartOptions = {
    chart: {
      id: 'user-activity',
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    xaxis: {
      categories: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    },
    stroke: {
      curve: 'smooth',
      width: 7,
      colors: ['#1b59f8']
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.6,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.7,
        stops: [0, 90, 100]
      }
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    dataLabels: {
      enabled: false
    }
  };

  const chartSeries = [
    {
      name: 'User Activity',
      data: [50, 80, 70, 90, 200, 160, 250, 230, 220, 240, 260, 320]
    }
  ];

  const [dashboardData, setDashboardData] = useState({ users: 0, products: 0, activeUsers: 0 });
  const [statData, setStatData] = useState(
    [
      {
        icon: <img src={Product} alt="Products" width="30" height="30" />,
        iconBg: '#fff9e6',
        count: '2,64,123',
        label: 'Total products'
      },
      {
        icon: <img src={User} alt="Products" width="30" height="30" />,
        iconBg: '#f5ede7',
        count: '2,64,123',
        label: 'Users'
      },
      {
        icon: <img src={Comp} alt="Products" width="30" height="30" />,
        iconBg: '#eaf8f9',
        count: '2,64,123',
        label: 'Active Comparisons'
      }
    ]
  )
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "BellyFul - Dashboard";
    fetchDashboardData();
  }, [])

  const fetchDashboardData = () => {
    setLoading(true)
    setDashboardData({})
    getDashboardData().then(({ data }) => {
      if (data.data) {
        // console.log('dashboard', data.data)
        setDashboardData(data.data ? data.data : { users: 0, products: 0, activeUsers: 0 })
        setStatData(data.data ? [
          {
            icon: <img src={Product} alt="Products" width="30" height="30" />,
            iconBg: '#fff9e6',
            count: data.data.products,
            label: 'Total products'
          },
          {
            icon: <img src={User} alt="Products" width="30" height="30" />,
            iconBg: '#f5ede7',
            count: data.data.users,
            label: 'Users'
          },
          {
            icon: <img src={Comp} alt="Products" width="30" height="30" />,
            iconBg: '#eaf8f9',
            count: data.data.activeUsers,
            label: 'Active Comparisons'
          }
        ] : [
          {
            icon: <img src={Product} alt="Products" width="30" height="30" />,
            iconBg: '#fff9e6',
            count: '0',
            label: 'Total products'
          },
          {
            icon: <img src={User} alt="Products" width="30" height="30" />,
            iconBg: '#f5ede7',
            count: '0',
            label: 'Users'
          },
          {
            icon: <img src={Comp} alt="Products" width="30" height="30" />,
            iconBg: '#eaf8f9',
            count: '0',
            label: 'Active Comparisons'
          }
        ])
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <Row className="mb-4">
            {
              statData.map((stat, index) => (
                <Col md="3" key={index}>
                  <Card className="" style={{ backgroundColor: '#ffffff' }}>
                    <CardBody className="d-flex align-items-center">
                      {loading ? <Skeleton className='me-3' height={40} width={40} circle /> : <div className="me-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: stat.iconBg, borderRadius: '50%', width: '50px', height: '50px' }}>{stat.icon}</div>}
                      <div>
                        {loading ? <Skeleton height={30} width={30} /> : <h5 className="mb-0 fw-700 fs-20">{stat.count}</h5>}
                        {loading ? <Skeleton height={20} width={80} /> : <small className="fs-14 fw-400 text-light">{stat.label}</small>}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))
            }
          </Row>
          <Row>
            <Col md="6">
              <Card className="">
                <CardBody>
                  <h6 className="fw-700 fs-20 mb-3">User Activity</h6>
                  <Chart
                    options={chartOptions}
                    series={chartSeries}
                    type="line"
                    height={300}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}